/**
 * Tiny API helper — all backend calls go through here.
 * Auth token (admin) is read from localStorage automatically.
 */
const BASE = import.meta.env.VITE_API_BASE || '';

function authHeader() {
  const t = typeof window !== 'undefined' ? localStorage.getItem('zvx-admin-token') : null;
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export async function api(path, opts = {}) {
  const res = await fetch(`${BASE}${path}`, {
    ...opts,
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      ...(opts.headers || {}),
    },
    body: opts.body && typeof opts.body !== 'string' ? JSON.stringify(opts.body) : opts.body,
  });
  const ct = res.headers.get('content-type') || '';
  const data = ct.includes('application/json') ? await res.json().catch(() => null) : await res.text();
  if (!res.ok) {
    const errMsg = data?.message || data?.error;
    throw new Error(typeof errMsg === 'string' ? errMsg : `HTTP ${res.status}`);
  }
  return data;
}

export const get  = (p)        => api(p);
export const post = (p, body)  => api(p, { method: 'POST', body });
export const put  = (p, body)  => api(p, { method: 'PUT',  body });
export const del  = (p)        => api(p, { method: 'DELETE' });
